//@ts-check
import { find, pickBy, isEmpty } from 'lodash-es';

// ? [REVISIT] we need TS bad or atleast optional chaning: so we don't need to `try catch` every function
type window_optimizely = {
  initialized: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get: (key: string) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  push: (data: any) => any;
};
// ? [REVISIT] do we need to do any other further safety checks to ensure `optimizely` exists before using it (keep in mind it's been added to the Head as a blocking script)
//@ts-ignore
const OPTIMIZELY: window_optimizely = window['optimizely'] || [];

// [BONUS] type & add `options` properties that passses along additional metadata (ex: tags)
export const manuallyActivatePage = (pageName: string) => {
  try {
    if (!OPTIMIZELY?.initialized) return;
    OPTIMIZELY.push({
      type: 'page',
      pageName,
    });
  } catch (err) {}
};
// ? [REVISIT] should we add manuallyActivateExperiment? how would we decide which `page` to activate?

export const getActiveVariations = (): VariationData[] => {
  try {
    if (!OPTIMIZELY?.initialized) return [];
    const variationMap: { [key: string]: NamedEntity } = OPTIMIZELY.get('state').getVariationMap();
    const activeVariations = Object.entries(variationMap).map(([experimentId, variationData]) => ({
      variationId: variationData.id,
      variationName: variationData.name,
      experimentId,
    }));
    return activeVariations;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const findVariationData = (input: VariationLookupInput): VariationData | undefined => {
  try {
    const activeVariations = getActiveVariations();
    const parsedInput = pickBy(input);
    if (isEmpty(parsedInput)) return undefined;
    //@ts-ignore // ? [REVISIT] ts is isn't just  {variationId: string;variationName: string;experimentId: string;}
    return find(activeVariations, parsedInput);
  } catch (err) {
    return undefined;
  }
};

const isExperimentActive = (experimentId: string) => {
  try {
    if (!OPTIMIZELY?.initialized) return false;
    const activeIds: string[] = OPTIMIZELY.get('state').getActiveExperimentIds();
    return activeIds.includes(experimentId);
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const checkIfInVariation = (input: VariationLookupInput): boolean => {
  if (!isExperimentActive(input.experimentId)) return false;
  const match = findVariationData(input);
  const isInVariation = !!match;
  return !!isInVariation;
};

export const manualActivationCheckIfInVariation = ({
  experimentId,
  variationId,
  pageName,
}: {
  experimentId: string;
  variationId: string;
  pageName: string;
}) => {
  const isAlreadyInBucket = checkIfInVariation({ experimentId });
  if (!isAlreadyInBucket) manuallyActivatePage(pageName);
  return checkIfInVariation({ experimentId, variationId });
};

export const getExperimentData = (experimentId: string) => {
  try {
    if (!OPTIMIZELY?.initialized) return null;
    const experimentStates: { [key: string]: ExperimentStateObject | undefined } = OPTIMIZELY.get(
      'state'
    ).getExperimentStates({
      // ? [REVISIT] (semantically) what is a 'decision' / what does it represent?
      decision: { experimentId },
      isActive: true,
    });
    const relevantExperiment = experimentStates[experimentId];
    return relevantExperiment;
  } catch (err) {
    return null;
  }
};

// Types
export type VariationData = {
  variationId: string;
  variationName: string;
  experimentId: string;
};
export type VariationLookupInput = { variationId?: string; experimentId: string; variationName?: string };

export interface ExperimentStateObject {
  audiences: NamedEntity[];
  variation: NamedEntity;
  visitorRedirected: boolean;
  isActive: boolean;
  id: string;
  experimentName: string;
  isInExperimentHoldback: boolean;
}

export interface NamedEntity {
  id: string;
  name: string;
}
